// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ENTER_EMAIL_OR_USERNAME_YOU_HAVE_REGISTERED = "Zadej email anebo login, kter\u00fd jsi zadala p\u0159i registraci:";
export const PASSWORD_RESET_EMAIL_OR_USERNAME_INVALID = "Toto nevypad\u00e1 jako spr\u00e1vn\u00e9 p\u0159ihla\u0161ovac\u00ed jm\u00e9no nebo e-mailov\u00e1 adresa";
export const SEND = "Ode\u0161li";
export const YOU_DID_NOT_ENTER_EMAIL = "Zapomn\u011bla jsi zadat tv\u016fj email.";
